<template>
  <nav class='player'>
    <play @toggle='toggle()' :paused='paused' />
    <nav class='meta' >
      <label>Audio</label>
      <time v-if='audio' class='duration' v-html=''>{{fmtMSS(parseInt(time))}} / {{duration}}</time>
      <meter v-if='audio' min='0' max="100" :value='progress' />
      <audio v-if='audio' preload='metadata' ref='audioPlayer' :src='audio' @timeupdate='timeupdate(); progressupdate();' @loadedmetadata='updateduration'/>
      <slot />
    </nav>
  </nav>
</template>

<style scoped>
  nav.player {
    display: flex;
    gap: 1em;
  }

  nav.meta {
    flex-grow: 5;
    font-size: 0.85em;
  }

  time.duration {
    float: right;
  }

meter {
   box-sizing: border-box;
   width: 100%;
   height: 0.5em;
   margin: 0;
   padding: 0;
   border-radius: 0.75em;
   border: none;
   outline: none;
   overflow: hidden;
   background-color: var(--darkmint);
   background-image: none;
   margin-top: 1em;
   margin-bottom: 0.5em;
 }

 meter::-webkit-meter-bar {
   box-sizing: border-box;
   height: 0.5em;
   background: transparent;
   outline: none;
   border: none;
   padding: 0;
   margin: 0;
 }

 meter::-webkit-meter-inner-element {
   box-sizing: border-box;
   height: 100%;
   background: none;
   background-image: none;
   padding: 0;
   margin: 0;
 }

 meter::-webkit-meter-optimum-value {
   box-sizing: border-box;
   height: 100%;
   background: transparent;
   background-image: none;
   background-color: var(--blue);
   padding: 0;
   margin: 0;
 }

 :-moz-meter-optimum::-moz-meter-bar {
   background-color: var(--blue);
   background-image: none;
 }

</style>

<script>
import mixins from '.././mixins.js';

export default {
  mixins: ['mixins'],
  props: ['audio'],
  data: function() {
    return {
      paused: true,
      progress: 0,
      time: '00.00',
      duration: '00.00',
      tracked: false
    }
  },
  beforeDestroy() {
    if(this.$refs.audioPlayer) this.$refs.audioPlayer.pause();
    this.paused = false;
  },
  computed: {

  },
  watch: {

  },
  methods: {
    toggle: function() {
      if(!this.$refs.audioPlayer.paused) {
        this.$refs.audioPlayer.pause();
        this.paused = true;
      } else if(this.$refs.audioPlayer.paused) {
        this.$refs.audioPlayer.play();
        this.paused = false;
        this.$gtag.event('click', {
          event_category: 'button',
          event_label: 'play',
          value: 1
        });
      }
    },
    timeupdate: function() {
      this.time = this.$refs.audioPlayer ? parseInt(this.$refs.audioPlayer.currentTime) : '00.00';
      if(this.time > 180 && !this.tracked) {
        this.$gtag.event('click', {
          event_category: 'button',
          event_label: 'played 180 over 10 seconds.',
          value: 1
        });
        this.tracked = true;
      }
    },
    progressupdate: function() {
      this.progress = this.$refs.audioPlayer ? parseInt((this.$refs.audioPlayer.currentTime / this.$refs.audioPlayer.duration) * 10000) / 100 : 0;
    },
    updateduration: function() {
      if(this.$refs.audioPlayer) this.duration = this.fmtMSS(parseInt(this.$refs.audioPlayer.duration));
    },
    fmtMSS(s){
      if(s > 0) {
        return (s-(s%=60))/60+(9<s?':':':0')+s
      }
      return '0:00'
    },
  }
}
</script>
